__turbopack_context__.v({
  "add-to-cart-button": "yaNQlG_add-to-cart-button",
  "add-to-wishlist-btn": "yaNQlG_add-to-wishlist-btn",
  "bundle-qty": "yaNQlG_bundle-qty",
  "buttons-container": "yaNQlG_buttons-container",
  "container-classes": "yaNQlG_container-classes",
  "grouped-price": "yaNQlG_grouped-price",
  "grouped-qty-text": "yaNQlG_grouped-qty-text",
  "grouped-row": "yaNQlG_grouped-row",
  "grouped-text": "yaNQlG_grouped-text",
  "heart-container": "yaNQlG_heart-container",
  "icon-circle": "yaNQlG_icon-circle",
  "img": "yaNQlG_img",
  "label": "yaNQlG_label",
  "launcherPdp": "yaNQlG_launcherPdp",
  "modal-content": "yaNQlG_modal-content",
  "modal-title": "yaNQlG_modal-title",
  "pdp-breadcrumbs": "yaNQlG_pdp-breadcrumbs",
  "pdp-container": "yaNQlG_pdp-container",
  "pdp-gallery-wrap": "yaNQlG_pdp-gallery-wrap",
  "pdp-info-wrap": "yaNQlG_pdp-info-wrap",
  "pdp-price": "yaNQlG_pdp-price",
  "pdp-product-price": "yaNQlG_pdp-product-price",
  "pdp-product-tag": "yaNQlG_pdp-product-tag",
  "pdp-quantity": "yaNQlG_pdp-quantity",
  "price-per-unit-cont": "yaNQlG_price-per-unit-cont",
  "product-details": "yaNQlG_product-details",
  "product-info": "yaNQlG_product-info",
  "product-main": "yaNQlG_product-main",
  "product-name": "yaNQlG_product-name",
  "product-topinfo": "yaNQlG_product-topinfo",
  "qr-code-button": "yaNQlG_qr-code-button",
  "qr-code-modal": "yaNQlG_qr-code-modal",
  "qty-selector": "yaNQlG_qty-selector",
  "quantity": "yaNQlG_quantity",
  "quantity-selector": "yaNQlG_quantity-selector",
  "rating": "yaNQlG_rating",
  "rating-container": "yaNQlG_rating-container",
  "separator": "yaNQlG_separator",
  "short-description": "yaNQlG_short-description",
  "sku": "yaNQlG_sku",
  "store-stock-item": "yaNQlG_store-stock-item",
  "store-stock-modal-container": "yaNQlG_store-stock-modal-container",
  "store-stock-modal-content": "yaNQlG_store-stock-modal-content",
  "store-stock-modal-list": "yaNQlG_store-stock-modal-list",
  "store-stock-modal-title": "yaNQlG_store-stock-modal-title",
  "store-stock-title": "yaNQlG_store-stock-title",
  "title": "yaNQlG_title",
  "wishlist-btn-container": "yaNQlG_wishlist-btn-container",
});
